import React from "react";

export default function Footer() {
    return (
        <footer className="py-12 px-6 text-center text-xs font-semibold uppercase tracking-[0.2em] text-stone-500 dark:text-stone-500">
            <div>
                © {new Date().getFullYear()} Natnael Adane |{" "}
                <a href="/privacy.html" className="hover:text-black dark:hover:text-white transition-colors">
                    Privacy
                </a>{" "}
                |{" "}
                <a href="/terms.html" className="hover:text-black dark:hover:text-white transition-colors">
                    Terms
                </a>
            </div>
        </footer>
    );
}
